var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8156 8.52244C6.18409 7.82585 7.14681 7.82585 7.51531 8.52244L11.2095 15.5056C11.565 16.1777 11.0973 17 10.3596 17H2.9713C2.23358 17 1.76592 16.1777 2.12144 15.5056L5.8156 8.52244Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4847 8.52244C16.8532 7.82585 17.8159 7.82585 18.1844 8.52244L21.8786 15.5056C22.2341 16.1777 21.7664 17 21.0287 17H13.6404C12.9027 17 12.435 16.1777 12.7905 15.5056L16.4847 8.52244Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle8);
export default __webpack_public_path__ + "static/media/triangle-8.8866404eecda8e9db30de47fef885fa8.svg";
export { ForwardRef as ReactComponent };